import React, { useState, useEffect } from "react";
import "./style.css";
import {
  CustomLabel,
  new_product_static_list_data,
  regex_obj,
  typeOfCal,
} from "../../Constant";
import CustomCard from "../../elements/CustomCard";
import InputComponent from "../../component/InputComponent";
import { message, Tooltip } from "antd";
import { Lifetime_req_obj } from "../../RequestData";
import moment from "moment";
import { Radio, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useGetDimensions } from "../../Hooks/useGetDemension";
import {
  InitialState,
  onMinusButtonCall,
  onPlusButtonCall,
  setPlanData,
} from "../../Redux/CIReducer";
import { useIsMobile } from "../../Hooks/useIsMobile";
import SarvahStepper from "../../component/StepperComponent/SarvahStepper";
import { getApi } from "../../service/ApiService";
import { endpoints } from "../../service/endpoints";
import Vector from "../../assets/images/Vector.png";
import { HTTPRequest } from "../../service/lib";

const AgePredict = (date, daysdiff = false) => {
  if (date == "") return "00";
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  if (`${newDate}` == "NaN") {
    return "00";
  }
  var current = moment().startOf("day");
  if (daysdiff) {
    var current = moment().startOf("day");
    return moment.duration(current.diff(new_date)).asDays();
  } else {
    return parseInt(newDate);
  }
};

const SarvahPage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const REDIRECTION = process.env.REACT_APP_REDIRECTIO_BASE_URL;
  const CI_coverType = useSelector((state) => state.CI.coverType);
  const {agentData: agentDataSelected , loginData} = useSelector((state) => state.agData);
  const obj = {
    dob: "",
    gender: "",
    relationship: "",
    annualI: "",
    si: "",
  };
  const [portValue, serPortValue] = useState("NO");
  const [commDiscountValue, setCommDiscountValue] = useState("NO");
  const [commDiscountRate, setCommDiscountRate] = useState("");
  const [userData, setUserData] = useState({
    adult: 2,
    child: 1,
    adultData: [obj, obj],
    childData: [obj],
    pincode: "",
    dropDownopen: false,
    isPort: portValue,
    isCommercialDiscount: commDiscountValue,
    commercialDiscountRate: commDiscountRate,
    check: true,
    dropDownError: false,
  });
  const typeOfCalculator = useSelector((state) => state.common.type);
  const headerHeight = useGetDimensions("banner", 0).height;
  const [ageError, setAgeError] = useState(false);
  const { adultMember, childMember, coverType } = useSelector(
    (state) => state.CI
  );
  const [toolTipContent, setToolTipContent] = useState("");

  useEffect(() => {
    setToolTipContent(
      "Get a discount on first policy year premium if intermediary forgoes their commission."
    );
  }, []);

  const discountListOptions = [
    { value: "ComDis5", label: "5%" },
    { value: "ComDis10", label: "10%" },
    { value: "ComDis15", label: "15%" },
  ];

  const ApiCall = async () => {
    let agevalidationOutput = validateIndividualDate();
    if (
      !ValidateAllInput() ||
      userData.pincode.length !== 6 ||
      !agevalidationOutput
    ) {
      return message.error("Please provide required information");
    }
    if (
      userData.isCommercialDiscount === "YES" &&
      !userData.commercialDiscountRate
    ) {
      return message.error("Please select discount rate");
    }
    if (!userData.phn) {
      return message.error("Please provide mobile number");
    }
    if (!userData.email) {
      return message.error("Please provide email Id");
    }
    if (!regex_obj.pincode.test(userData.pincode)) {
      return message.error("Please provide valid pincode");
    }
    if (!regex_obj.phoneNumberValid.test(userData.phn)) {
      return message.error("Please provide valid mobile number");
    }
    if (!regex_obj.emailValidation.test(userData.email)) {
      return message.error("Please provide valid email Id");
    }
    dispatch(setPlanData(userData));
    try {
      /* const res = await getApi(
        endpoints.sarvah_pincode + `${userData.pincode}/app/sarvah`
      ); */
      const pincode_url= endpoints.sarvah_pincode + `${userData.pincode}/app/sarvah`
      const res_data = await HTTPRequest.GET("pincode", pincode_url);
      let res = res_data.response;
      if (res) {
        const obj = Lifetime_req_obj({
          userData,
          type: typeOfCalculator,
          zone: res.zonecd,
          agentData: agentDataSelected,
          intermediarySubCatCd:loginData.intermedsubcatcd,
          CI_coverType: CI_coverType.toLowerCase().includes("family")
            ? "familyfloater"
            : CI_coverType,
        });
        const url = `${REDIRECTION}sell-sarvah/quick-quote/your-quote?q=${obj}`;
        if(url.includes(REDIRECTION)){
          window.location.href = url;
        }
      }
    } catch (err) {
      console.error(err);
      message.error("Service unavailable for this Pincode");
    }
  };
  const validateIndividualDate = () => {
    const age_check = userData.adultData.every(
      (ei) => AgePredict(ei.dob) >= 18 && AgePredict(ei.dob) <= 120
    );
    let child_check = true;
    return age_check && child_check;
  };
  const ValidateAllInput = () => {
    const chid_age = userData.childData.some((ei) => AgePredict(ei.dob) >= 18 ) 
    if( userData.adultData.length === 0 &&  chid_age){
      return
    }
    if (
      userData.adultData
        .filter((ei) => ei.annualI > 0)
        .some((ei) => !(ei.annualI >= 25000))
    ) {
      return;
    }
    const data_A = userData.adultData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== "" // && ei.si != ""
    );
    const data_C = userData.childData.every(
      (ei) => ei.dob !== "" && ei.gender !== "" && ei.relationship !== "" // && ei.si != ""
    );

    const spouse = userData.adultData.filter(
      (ei) => ei.relationship == "SPOUSE"
    );
    const self = userData.adultData.filter((ei) => ei.relationship == "SELF");
    const otherDependent = [
      ...userData.adultData,
      ...userData.childData,
    ].filter((ei) => ei.relationship != "SPOUSE" && ei.relationship !== "SELF");
    // const incomeCheck = coverType == typeOFCOVER.ff &&  self[0]?.si < (otherDependent.length > 0 ? 850000 : spouse[0]?.annualI == 0 ? 500000 : true)
    const age_check = userData.adultData.every(
      (ei) => AgePredict(ei.dob) >= 18 && AgePredict(ei.dob) <= 120
    );
    //const childAge_Bro_Sis = userData.childData.filter((ei) =>["sister", "brother"].includes(ei.relationship.toLocaleLowerCase())).every((ei) => AgePredict(ei.dob , true) >= 91 && AgePredict(ei.dob) <= 30);
    const relationKID = userData.childData.filter((ei) =>["son", "daughter"].includes(ei.relationship.toLocaleLowerCase()))
    const childAge_Son_daughter = relationKID.every((ei) => AgePredict(ei.dob, true) >= 91 && AgePredict(ei.dob) <= 30);
    setAgeError(
      !(
        data_A &&
        data_C &&
        //childAge_Bro_Sis &&
        age_check &&
        childAge_Son_daughter
      )
    );
    return (
      //data_A && data_C && childAge_Son_daughter && age_check && childAge_Bro_Sis
      data_A && data_C && childAge_Son_daughter && age_check

    );
  };

  const okButtnClick = () => {
    if (!ValidateAllInput()) {
      return message.error("Please provide required information");
    }
    setUserData({ ...userData, dropDownopen: false });
  };

  const setMinusButton = (e) => {
    // if (e === "Adult" && parseInt(userData.adult) === 1) {
    //   return message.error("Need to select atleast one Adult");
    // }
    dispatch(onMinusButtonCall({ type: e }));
  };

  const setPlusButton = (e) => {
    // if (e === "Adult" && parseInt(userData.adult) >= 2) {
    //   return message.error("You have selected meaximum number of adult");
    // }
    // if (e === "Child" && parseInt(userData.child) >= 3) {
    //   return message.error("You have selected meaximum number of child");
    // }
    if (parseInt(userData.adult) + parseInt(userData.child) >= 8) {
      return message.error("You had selected maximum member");
    }
    dispatch(onPlusButtonCall({ type: e }));
  };

  useEffect(() => {
    dispatch(InitialState());
    dispatch(onMinusButtonCall({ type: "Adult" }));
    dispatch(onMinusButtonCall({ type: "Child" }));
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
  }, []);

  useEffect(() => {
    setUserData({
      ...userData,
      adult: adultMember.length,
      adultData: adultMember,
      child: childMember.length,
      childData: childMember,
    });
  }, [adultMember, childMember]);

  const handleKeyNumber = (e) => {
    var firstDigit = e.target.value.charAt(0);

    if (
      firstDigit === "0" ||
      firstDigit === "1" ||
      firstDigit === "2" ||
      firstDigit === "3" ||
      firstDigit === "4" ||
      firstDigit === "5"
    ) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setUserData({ ...userData, phn: e.target.value });
    }
  };

  const onPortChange = ({ target: { value } }) => {
    serPortValue(value);
    setUserData({ ...userData, isPort: value });
  };

  const onCommertialDiscountChange = ({ target: { value } }) => {
    setCommDiscountValue(value);
    setUserData({ ...userData, isCommercialDiscount: value });
  };

  const onDiscountRateChange = (value) => {
    setCommDiscountRate(value);
    setUserData({ ...userData, commercialDiscountRate: value });
  };

  return (
    <div
      className="bg-color py-4 font-family container-fluid custom-container"
      style={{ marginTop: `${parseInt(headerHeight)}px` }}
    >
      {/* <CustomToast /> */}
      <div>
        <CustomLabel font_size="28" className="my-4">
          Sarvah Quotation
        </CustomLabel>
      </div>
      <div className="row">
        <div className="col-xl-8 col-12">
          <div className="">
            <CustomCard cardName={typeOfCal.mchiSarvah}>
              <div className="row mb-4">
                <div className="col-lg-6 col-12">
                  <div>
                    <CustomLabel font_size="14">
                      Number of members to secure &nbsp;&nbsp;
                    </CustomLabel>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <SarvahStepper
                        plusClicked={(e) => setPlusButton("Adult")}
                        minusClicked={(e) => setMinusButton("Adult")}
                        label={"Adults"}
                        value={userData.adult}
                      />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <SarvahStepper
                        plusClicked={(e) => setPlusButton("Child")}
                        minusClicked={(e) => setMinusButton("Child")}
                        label={"Kids"}
                        value={userData.child}
                      />
                    </div>
                  </div>
                  <div className="my-3">
                    <CustomLabel
                      font_size="12"
                      color="#c3c2c2"
                      className="d-flex align-items-start"
                    >
                      <img
                        src={Vector}
                        alt="Info icon"
                        className="me-1"
                        style={{ height: "14px", width: "14px" }}
                      />
                      <span>
                        Select the number of adults (ages 18 and above) and
                        children to be covered by the insurance.
                      </span>
                    </CustomLabel>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Date of Birth & Gender"}
                        placeholder="Enter DOB & Gender"
                        value={
                          userData.adultData.length > 0
                            ? userData.adultData[0]?.dob
                            : userData.childData[0]?.dob
                        }
                        onChange={(e) => {
                          setUserData({ ...userData, dropDownopen: true });
                        }}
                        onCancel={(e) => {
                          setUserData({ ...userData, dropDownopen: false });
                        }}
                        onOk={() => {
                          okButtnClick();
                        }}
                        onDataChange={() => {}}
                        data={userData}
                        dropdownComponent={true}
                        dropDownopen={userData.dropDownopen}
                        readOnly={true}
                        ageError={ageError}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Pincode"}
                        regex={regex_obj.pincode}
                        placeholder="Enter Pincode"
                        value={userData.pincode}
                        onChange={(e) => {
                          setUserData({ ...userData, pincode: e.target.value });
                        }}
                        maxLength={6}
                      />
                    </div>
                    <div className="my-3">
                      <CustomLabel
                        font_size="12"
                        font_weight="bold"
                        color="#c3c2c2"
                        className="d-flex align-items-start"
                      >
                        <img
                          src={Vector}
                          alt="Info icon"
                          className="me-1"
                          style={{ height: "14px", width: "14px" }}
                        />
                        <span>
                          Same as mentioned in Aadhaar card / Passport / Driving
                          License or any other document
                        </span>
                      </CustomLabel>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <InputComponent
                    label={"Phone number"}
                    regex={regex_obj.phoneNumberValid}
                    placeholder="Enter Your Phone Number"
                    value={userData.phn}
                    onChange={(e) => {
                      handleKeyNumber(e);
                    }}
                    extraData={true}
                    maxLength={10}
                  />
                </div>
                <div
                  className={
                    isMobile ? "col-md-6 col-12 mb-4" : "col-md-6 col-12"
                  }
                >
                  <InputComponent
                    label={"Email"}
                    regex={regex_obj.emailValidation}
                    placeholder="Enter Your Email ID"
                    value={userData.email}
                    onChange={(e) => {
                      setUserData({ ...userData, email: e.target.value });
                    }}
                  />
                </div>
                {agentDataSelected?.channel !== "148" && (
                  <div className="col-md-6 col-12 d-none">
                    <div className="d-flex">
                      <label className="radio-button-label mb-2 mt-3">
                        Do you wish to apply a commercial discount for this
                        plan? &nbsp; &nbsp;{" "}
                      </label>
                      <Tooltip title={toolTipContent} className="mt-3">
                        <img
                          src={Vector}
                          alt="Info icon"
                          style={{ height: "14px", width: "14px" }}
                        />
                      </Tooltip>
                    </div>

                    <Radio.Group
                      onChange={onCommertialDiscountChange}
                      value={commDiscountValue}
                      className="w-100"
                    >
                      <div className="row">
                        <div className="col-6 radio-button-style">
                          <Radio value={"YES"}>Yes</Radio>
                        </div>
                        <div className="col-6 radio-button-style">
                          <Radio value={"NO"}>No</Radio>
                        </div>
                      </div>
                    </Radio.Group>
                  </div>
                )}
                <div className="col-md-6 col-12">
                  <label className="radio-button-label mb-2 mt-3">
                    Are you looking to Port/Migrate you Health Insurance?
                  </label>
                  <br />
                  <Radio.Group
                    onChange={onPortChange}
                    value={portValue}
                    className="w-100"
                  >
                    <div className="row">
                      <div className="col-6 radio-button-style">
                        <Radio value={"YES"}>Yes</Radio>
                      </div>
                      <div className="col-6 radio-button-style">
                        <Radio value={"NO"}>No</Radio>
                      </div>
                    </div>
                  </Radio.Group>
                </div>
                {commDiscountValue === "YES" && (
                  <div className="col-md-6 col-12">
                    <label className="radio-button-label mb-2 mt-3">
                      Discount rate
                    </label>
                    <br />
                    <Select
                      placeholder="Select discount rate"
                      style={{ width: "100%" }}
                      onChange={onDiscountRateChange}
                      options={discountListOptions}
                    />
                  </div>
                )}
              </div>
            </CustomCard>
            <div className="col-12 card_footer" onClick={ApiCall}>
              <CustomLabel color="white">
                {"Get Quotes".toLocaleUpperCase()}
              </CustomLabel>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-12 insurance-benefits-container">
          <div className="list mt-3 mt-xl-0">
            {new_product_static_list_data.map((item) => {
              return (
                <div
                  key={`${item.key}`}
                  className="row insurance-benefits mt-3"
                >
                  <div className="col-1 col-xl-2 icon">
                    <div>{item.icon}</div>
                  </div>
                  <div className="col-11 col-xl-10 my-2">
                    <CustomLabel
                      font_size="12"
                      padding_left="5px"
                      padding_top="8px"
                      font_weight="normal"
                      color="#57585A"
                    >
                      {item.desc}
                    </CustomLabel>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SarvahPage;
